module.exports = __webpack_public_path__ + "img/fast-delivery-neo.43e65ea.svg";